import * as React from 'react'
import styles from './style.module.css';
import { UseCRUDDropoffs } from '../../../hooks/useCRUD_Dropoffs';
import DeliveryNewOrder from '../delivery';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import IconProvider from '../../../design-system/lib/IconProvider';
import { ADD_SQUARE, ROUTE_OPTIMIZE } from '../../../assets';
import Typography from '../../../design-system/lib/Typography';



function AddDropOff({ orderTypeActive, addDropOff }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  if (orderTypeActive == "Ondemand") {
    return (
      <div className={styles.AddDropOff} onClick={addDropOff}>
        <hr className={styles.hr} />
        <IconProvider Icon={ADD_SQUARE} size='16' />
        <Typography weight='Body_Middle_Medium' text={t("AddDropoff")} textColor='TextDark' />
 
      </div>
    )
  } else {
    return null
  }
}

export default AddDropOff